<template>
  <div class="media one_comment_container">
    <img :src="image_url+comment.user.avatar" class="mr-3 rounded-circle" alt="..." width="50" height="50">
    <div class="media-body">
      <h5 class="mt-0">{{ comment.user.name }}</h5>
      <span><i class="fa fa-calendar"></i> {{ comment.created_at }}</span>
      <p><mark>изменил статус с {{ comment.old_status.title}} на {{ comment.new_status.title}}</mark></p>
    </div>

  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: 'StatusHistoryProjectBlock',
  data(){
    return {
      'image_url':""
    };
  },
  props: {
    comment: Object
  },
  mounted() {
    var app=this;
    app.image_url = Vue.config.IMAGE_URL;

  }
}
</script>

<style scoped>
.media {
  margin-top: 1rem;
}
</style>